import { Accordion, Box, Heading, Paragraph, Text } from '@zillow/constellation-10';

import type { Lease, Summary } from '../../models';
import type { EnteredValue, SectionCategory } from '../../models/Summary';
import { FULLSTORY_EXCLUDE } from '../../constants/analytics';

type Props = {
  lease: Lease;
  summary: Summary;
};

function SummaryReadOnly({ summary }: Props) {
  if (!summary || !summary.sectionCategories) {
    return null;
  }

  return (
    <>
      <Accordion.Root defaultExpanded={Array.from(Array(summary.sectionCategories.length).keys()).map(String)}>
        {summary.sectionCategories.map((sectionCategory: SectionCategory, index) => {
          return (
            <Accordion.Item key={sectionCategory.sectionCategory} value={String(index)}>
              <Accordion.Header>
                <Heading level={3} css={{ textStyle: 'responsive.heading-xs' }}>
                  {sectionCategory.displayName}
                </Heading>
              </Accordion.Header>
              <Accordion.Panel>
                {sectionCategory.enteredValues.map((enteredValue: EnteredValue, summaryIndex) => (
                  <Box
                    key={summaryIndex}
                    css={{
                      display: 'grid',
                      gridTemplateColumns: 'repeat(12, 1fr)',
                      gap: 'tighter',
                      marginBottom: summaryIndex === sectionCategory.enteredValues.length - 1 ? 0 : 'tight',
                    }}
                  >
                    <Box css={{ gridColumnEnd: { base: 'span 12', md: 'span 4' } }}>
                      <Text css={{ textStyle: 'body-sm', fontWeight: 'bold' }}>{enteredValue.fieldDisplayName}</Text>
                    </Box>
                    <Box css={{ gridColumnEnd: { base: 'span 12', md: 'span 4' } }}>
                      {enteredValue.fieldValues &&
                        enteredValue.fieldValues.map((fieldValue, fieldValueIndex) => (
                          <Paragraph css={{ textStyle: 'body-sm' }} className={FULLSTORY_EXCLUDE} key={fieldValueIndex}>
                            {fieldValue}
                          </Paragraph>
                        ))}
                    </Box>
                  </Box>
                ))}
              </Accordion.Panel>
            </Accordion.Item>
          );
        })}
      </Accordion.Root>
    </>
  );
}

export default SummaryReadOnly;
